export const Default_CIP_INFORMATION = (minTemp, maxTemp) => {
  return {
    backwashes: {
      design_duration_btw_bw: {
        key: "design_duration_btw_bw",
        minValue: 10,
        maxValue: 90,
      },
      design_bw_duration: {
        key: "design_bw_duration",
        minValue: 1,
        maxValue: 5,
      },
    },
    cebs: {
      acid_ceb_duration: {
        key: "acid_ceb_duration",
        minValue: 24,
        maxValue: 154,
      },
      acid_ceb_soak_duration: {
        key: "acid_ceb_soak_duration",
        minValue: 5,
        maxValue: 60,
      },
      acid_used_per_ceb: {
        key: "acid_used_per_ceb",
        minValue: 0,
        maxValue: 100,
      },
      acid_ceb_ph: { key: "acid_ceb_ph", minValue: 2, maxValue: 7 },
      acid_ceb_temp: { key: "acid_ceb_temp", minValue: minTemp, maxValue: maxTemp },
      alkali_ceb_duration: {
        key: "alkali_ceb_duration",
        minValue: 12,
        maxValue: 154,
      },
      alkali_ceb_soak_duration: {
        key: "alkali_ceb_soak_duration",
        minValue: 5,
        maxValue: 60,
      },
      alkali_used_per_ceb: {
        key: "alkali_used_per_ceb",
        minValue: 0,
        maxValue: 100,
      },
      alkali_ceb_ph: { key: "alkali_ceb_ph", minValue: 7, maxValue: 12 },
      alkali_ceb_temp: { key: "alkali_ceb_temp", minValue: minTemp, maxValue: maxTemp },
    },
    cips: {
      acid_cip_duration: {
        key: "acid_cip_duration",
        minValue: 15,
        maxValue: 360,
      },
      acid_cip_soak_duration: {
        key: "acid_cip_soak_duration",
        minValue: 1,
        maxValue: 24,
      },
      acid_used_per_cip: {
        key: "acid_used_per_cip",
        minValue: 0,
        maxValue: 100,
      },
      acid_cip_ph: { key: "acid_cip_ph", minValue: 2, maxValue: 7 },
      acid_cip_temp: { key: "acid_cip_temp", minValue: minTemp, maxValue: maxTemp },
      alkali_cip_duration: {
        key: "alkali_cip_duration",
        minValue: 15,
        maxValue: 360,
      },
      alkali_cip_soak_duration: {
        key: "alkali_cip_soak_duration",
        minValue: 1,
        maxValue: 24,
      },
      alkali_used_per_cip: {
        key: "alkali_used_per_cip",
        minValue: 0,
        maxValue: 100,
      },
      alkali_cip_ph: { key: "alkali_cip_ph", minValue: 7, maxValue: 12 },
      alkali_cip_temp: { key: "alkali_cip_temp", minValue: minTemp, maxValue: maxTemp },
    },
  };
};
export const PLANT_DETAILS = () => {
  return {
    add: {
      add_info: {
        key: "add_info",
        multiline: "2",
        maxChar: 250,
      },
    },
  };
};
export const ADD_CIP_INFORMATION = (
  type,
  minTemp,
  maxTemp,
  minAcidUsed,
  maxAcidUsed
) => {
  return {
    cips: {
      acid_soak_duration: {
        key: "acid_soak_duration",
        minValue: type === "ceb" ? 5 : 1,
        maxValue: type === "ceb" ? 60 : 24,
      },
      acid_used: {
        key: "acid_used",
        minValue: minAcidUsed,
        maxValue: maxAcidUsed,
      },
      acid_ph: { key: "acid_ph", minValue: 2, maxValue: 7 },
      acid_temp: { key: "acid_temp", minValue: minTemp, maxValue: maxTemp },

      alkali_soak_duration: {
        key: "alkali_soak_duration",
        minValue: type === "ceb" ? 5 : 1,
        maxValue: type === "ceb" ? 60 : 24,
      },
      alkali_used: {
        key: "alkali_used",
        minValue: minAcidUsed,
        maxValue: maxAcidUsed,
      },
      alkali_ph: { key: "alkali_ph", minValue: 7, maxValue: 12 },
      alkali_temp: { key: "alkali_temp", minValue: minTemp, maxValue: maxTemp },
    },
  };
};
